import api from 'api';

export function updateAgent(organizationId, agentId, data) {
    const allowedFields = ['status', 'currentEvent', 'sessionId'];
    const sanitized = Object.keys(data)
        .filter((key) => allowedFields.includes(key))
        .reduce((obj, key) => ({ ...obj, [key]: data[key] }), {});
    return api.put(`users/realtime/${organizationId}`, { ...sanitized, id: agentId });
}

export function setAgentOnline(agent) {
    const { id, organizationId, name, avatar, username } = agent;
    return api.put(`users/realtime/online/${organizationId}`, { id, name, avatar, username });
}

/**
 * Ends the agent's presence in the dashboard (`onlineWeb: false`). `forcedOffline` is the agent's
 * Availability, Unavailable, and is only sent when it is the point: `true` for the switch turned
 * off (the app and the chat service read it too). A sign-out or a tab closing ends presence only and
 * sends nothing about it, so an Unavailable set elsewhere survives.
 */
export function setAgentOffline(organizationId, agentId, forcedOffline) {
    const body = forcedOffline === undefined ? { agentId } : { agentId, forcedOffline };
    return api.put(`users/realtime/offline/${organizationId}`, body);
}

/**
 * Ends the agent's presence as the page goes away. `keepalive` lets the request outlive the page,
 * and unlike `navigator.sendBeacon` (always a POST) it can send the PUT the route needs, with the
 * session cookie and the organization header every other call carries. Presence only: it says
 * nothing about `forcedOffline`.
 */
export function endAgentPresenceOnUnload(organizationId, agentId) {
    return fetch(`${api.defaults.baseURL}/users/realtime/offline/${organizationId}`, {
        method: 'PUT',
        keepalive: true,
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', 'x-onlive-organization-id': organizationId },
        body: JSON.stringify({ agentId }),
    }).catch(() => undefined);
}

export function setAgentOfflineMobile(organizationId, agentId, forcedOffline = false) {
    return api.put(`users/realtime/offline-mobile/${organizationId}`, { agentId, forcedOffline });
}
